import { MASTER_HOME } from "../../helpers/masterUser";

export function getMasterRouteMeta(pathname) {
	if (pathname === MASTER_HOME) {
		return {
			titleKey: "master.pages.dashboardTitle",
			subtitleKey: "master.pages.dashboardSubtitle",
			breadcrumbs: [{ labelKey: "master.nav.dashboard" }],
		};
	}
	if (pathname === `${MASTER_HOME}/companies`) {
		return {
			titleKey: "master.pages.companiesTitle",
			subtitleKey: "master.pages.companiesListSubtitle",
			breadcrumbs: [
				{ labelKey: "master.nav.dashboard", to: MASTER_HOME },
				{ labelKey: "master.nav.companies" },
			],
		};
	}
	if (pathname.startsWith(`${MASTER_HOME}/companies/`) && pathname.endsWith("/edit")) {
		return {
			titleKey: "master.pages.editCompanyTitle",
			breadcrumbs: [
				{ labelKey: "master.nav.dashboard", to: MASTER_HOME },
				{ labelKey: "master.nav.companies", to: `${MASTER_HOME}/companies` },
				{ labelKey: "master.pages.editCompanyTitle" },
			],
		};
	}
	if (pathname === `${MASTER_HOME}/plans`) {
		return {
			titleKey: "master.plans.pageTitle",
			subtitleKey: "master.plans.pageSubtitle",
			breadcrumbs: [
				{ labelKey: "master.nav.dashboard", to: MASTER_HOME },
				{ labelKey: "master.nav.plans" },
			],
		};
	}
	if (pathname === `${MASTER_HOME}/addons`) {
		return {
			titleKey: "master.addons.pageTitle",
			subtitleKey: "master.addons.pageSubtitle",
			breadcrumbs: [
				{ labelKey: "master.nav.dashboard", to: MASTER_HOME },
				{ labelKey: "master.nav.addons" },
			],
		};
	}
	if (pathname === `${MASTER_HOME}/coupons`) {
		return {
			titleKey: "master.coupons.pageTitle",
			subtitleKey: "master.coupons.pageSubtitle",
			breadcrumbs: [
				{ labelKey: "master.nav.dashboard", to: MASTER_HOME },
				{ labelKey: "master.nav.coupons" },
			],
		};
	}
	if (pathname === `${MASTER_HOME}/finance`) {
		return {
			titleKey: "master.finance.pageTitle",
			subtitleKey: "master.finance.pageSubtitle",
			breadcrumbs: [
				{ labelKey: "master.nav.dashboard", to: MASTER_HOME },
				{ labelKey: "master.nav.finance" },
			],
		};
	}
	if (pathname === `${MASTER_HOME}/system`) {
		return {
			titleKey: "master.pages.systemTitle",
			subtitleKey: "master.pages.systemSubtitle",
			breadcrumbs: [
				{ labelKey: "master.nav.dashboard", to: MASTER_HOME },
				{ labelKey: "master.nav.system" },
			],
		};
	}
	if (
		pathname === `${MASTER_HOME}/documents` ||
		pathname.startsWith(`${MASTER_HOME}/documents/`)
	) {
		return {
			titleKey: "master.documents.pageTitle",
			subtitleKey: "master.documents.pageSubtitle",
			breadcrumbs: [
				{ labelKey: "master.nav.dashboard", to: MASTER_HOME },
				{ labelKey: "master.nav.documents" },
			],
		};
	}
	if (pathname === `${MASTER_HOME}/busca/usuarios-por-empresa`) {
		return {
			titleKey: "master.pages.searchUsersTitle",
			subtitleKey: "master.pages.searchUsersSubtitle",
			breadcrumbs: [
				{ labelKey: "master.nav.dashboard", to: MASTER_HOME },
				{ labelKey: "master.nav.searchUsers" },
			],
		};
	}
	if (
		pathname === `${MASTER_HOME}/agendamentos/logs` ||
		pathname.startsWith(`${MASTER_HOME}/agendamentos/logs/`)
	) {
		const onTrack = pathname !== `${MASTER_HOME}/agendamentos/logs`;
		return {
			titleKey: onTrack ? "master.scheduleLogs.trackPageTitle" : "master.scheduleLogs.pageTitle",
			subtitleKey: "master.scheduleLogs.pageSubtitle",
			breadcrumbs: [
				{ labelKey: "master.nav.dashboard", to: MASTER_HOME },
				{
					labelKey: "master.nav.scheduleLogs",
					to: `${MASTER_HOME}/agendamentos/logs`,
				},
				...(onTrack ? [{ labelKey: "master.scheduleLogs.trackBreadcrumb" }] : []),
			],
		};
	}
	if (
		pathname === `${MASTER_HOME}/envio-massa/logs` ||
		pathname.startsWith(`${MASTER_HOME}/envio-massa/logs/`)
	) {
		const onTrack = pathname !== `${MASTER_HOME}/envio-massa/logs`;
		return {
			titleKey: onTrack ? "master.bulkMessagingLogs.trackPageTitle" : "master.bulkMessagingLogs.pageTitle",
			subtitleKey: "master.bulkMessagingLogs.pageSubtitle",
			breadcrumbs: [
				{ labelKey: "master.nav.dashboard", to: MASTER_HOME },
				{
					labelKey: "master.nav.bulkMessagingLogs",
					to: `${MASTER_HOME}/envio-massa/logs`,
				},
				...(onTrack ? [{ labelKey: "master.bulkMessagingLogs.trackBreadcrumb" }] : []),
			],
		};
	}
	return {
		titleKey: "master.layout.title",
		breadcrumbs: [{ labelKey: "master.nav.dashboard", to: MASTER_HOME }],
	};
}
